export default __webpack_public_path__ + "static/media/booking-history.50992650.svg";